import { emitter } from '@/core/emitter';
import { useUserStore } from '@/stores/user';

/**
 * Gate an action on being logged in.
 *
 * Returns true when the user is already logged in. When they aren't, it opens
 * the login popup (mounted once in ApplicationLayout) and returns false — the
 * user logs in without leaving the page, so whatever they were doing (a
 * take-bet modal on the price they clicked, a game they were creating) is
 * still there afterwards.
 */
export function checkAuthAndShowLogin() {
  const userStore = useUserStore();
  if (!userStore.user.isLoggedIn) {
    emitter.emit('showLoginModal');
    return false;
  }
  return true;
}
